import { Fragment, React } from 'libs/react';
import { EmptyData } from 'components/EmptyData';
import { DateTime } from 'components/DateTime';
import { Text } from 'components/Text';
import { Button } from 'components/Button';
import { Requires } from 'components/user/Requires';
import './DealApprovalPane.scss';
import { Table } from 'components/table/Table';
/**
 * @component DealApprovalPane
 * @since 1.0.0
 */
export function DealApprovalPane(props) {
    var _a;
    const { data, onCancelSignature } = Object.assign({}, props);
    const approbations = [...((_a = data === null || data === void 0 ? void 0 : data.approbations) !== null && _a !== void 0 ? _a : [])].sort((a, b) => { var _a, _b; return String((_a = b.createdAt) !== null && _a !== void 0 ? _a : '').localeCompare(String((_b = a.createdAt) !== null && _b !== void 0 ? _b : '')); });
    const schema = {
        c1: {
            column: 'date',
            header: t('Date'),
            footer: t('Date'),
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(DateTime, { value: value.createdAt, y: "numeric", m: "numeric", d: "numeric", time: true })));
            }
        },
        c2: {
            column: 'state',
            header: t('Status'),
            footer: t('Status'),
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { value: value.state === 'APPROVED'
                            ? t('Approved')
                            : value.state === 'ACCEPTED'
                                ? t('Accepted')
                                : value.state === 'REVERTED'
                                    ? t('Cancelled')
                                    : t('Rejected') })));
            }
        },
        c3: {
            column: 'user',
            header: t('By'),
            footer: t('By'),
            render: (value) => {
                var _a;
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { value: ((_a = value.user) === null || _a === void 0 ? void 0 : _a.fullname)
                            ? value.user.fullname
                            : value.firstName
                                ? value.firstName + ' ' + value.lastName
                                : t('End User') })));
            }
        }
    };
    return (React.createElement("div", null,
        ((data === null || data === void 0 ? void 0 : data.status) === 'WON' || (data === null || data === void 0 ? void 0 : data.status) === 'SIGNED') &&
            onCancelSignature && (React.createElement(Requires, { permission: "deal.update" },
            React.createElement("div", { className: "deal-approval-pane-header" },
                React.createElement(Button, { style: "secondary", picto: "file-xmark", size: "small", label: t('Cancel signature'), onPress: onCancelSignature })))),
        approbations.length > 0 ? (React.createElement(Table, { schema: schema, values: approbations, className: "deal-approval-pane-table" })) : (React.createElement(EmptyData, { title: t('No approbation'), description: t('There is no approbation for this deal.') }))));
}
